import { render, staticRenderFns } from "./PersonnelDetail.vue?vue&type=template&id=fc68753e&"
import script from "./PersonnelDetail.vue?vue&type=script&lang=js&"
export * from "./PersonnelDetail.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports